import { combineReducers } from 'redux';

import { reducer as list } from './listModule';
import { reducer as update } from './updateModule';

export default combineReducers({
	list,
	update,
});
